import { render, staticRenderFns } from "./petitionedCase.vue?vue&type=template&id=57893cde&scoped=true&"
import script from "./petitionedCase.vue?vue&type=script&lang=js&"
export * from "./petitionedCase.vue?vue&type=script&lang=js&"
import style0 from "./petitionedCase.vue?vue&type=style&index=0&id=57893cde&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57893cde",
  null
  
)

export default component.exports